import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, createElementVNode as _createElementVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "p-3 text-muted"
}
const _hoisted_2 = { class: "item d-flex align-items-center" }
const _hoisted_3 = { class: "pr-3" }
const _hoisted_4 = { class: "flex-fill" }
const _hoisted_5 = { class: "name" }
const _hoisted_6 = { class: "dates d-flex" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "date" }
const _hoisted_9 = {
  key: 1,
  class: "text-muted"
}
const _hoisted_10 = {
  key: 0,
  style: {"height":"6em","line-height":"4em","overflow":"hidden"},
  class: "p-3"
}

import {computed, nextTick, onMounted} from "vue";
import ReactiveRequest from "~/core-ui/ts/request/ReactiveRequest";
import OperatorApiRequestFactory from "~/operatorApplication/ts/request/OperatorApiRequestFactory";
import ReactiveRequestLoader from "~/cabinet/vue/interface/data/ReactiveRequestLoader.vue";
import MyLoader from "~/cabinet/vue/interface/data/MyLoader.vue";
import {__} from "~/ts/library/Translate";
import DateHelper from "../../../ts/library/Date";
import CoreUiChatHistoryMessageStatus from "~/core-ui/vue/chat/CoreUiChatHistoryMessageStatus.vue";
import CoreUiOperatorAvatar from "~/core-ui/vue/chat/CoreUiOperatorAvatar.vue";
import ObjectHelper from "~/ts/library/ObjectHelper";
import CoreUiChatClientAvatar from "~/core-ui/vue/chat/CoreUiChatClientAvatar.vue";

import OperatorMessageGetStatusLogOpenApiModel = OperatorApplicationApi.OperatorMessageGetStatusLogOpenApiModel;
import OperatorMessageGetStatusLogResultOpenApiModel = OperatorApplicationApi.OperatorMessageGetStatusLogResultOpenApiModel;
import OperatorApplicationMessageStatusLogOpenApiModel = OperatorApplicationApi.OperatorApplicationMessageStatusLogOpenApiModel;

import {defineComponent} from 'vue';

const __default__ = defineComponent({
    name: "CoreUiChatHistoryMessageStatusPopover"
});

export default /*@__PURE__*/_defineComponent({
  ...__default__,
  props: {
    messageId: {},
    operators: {},
    showOperatorLogins: { type: Boolean },
    client: {}
  },
  emits: ["reposition", "close"],
  setup(__props: any, { emit: __emit }) {

let props = __props;

let emits = __emit

let request = computed(() => {
    let p: OperatorMessageGetStatusLogOpenApiModel = {
        messageId: props.messageId
    }
    return (new ReactiveRequest<OperatorMessageGetStatusLogResultOpenApiModel>(
        OperatorApiRequestFactory.create({
            url: "/message/getMessageStatusLog",
            p
        })
    )).setCallback(() => {
        nextTick(() => emits('reposition'));
    }).setErrorCallback(() => {
        emits('close');
    });
});

let operators = computed(() => ObjectHelper.dictionaryFromArray(props.operators, "login"));

function getOperator(item: OperatorApplicationMessageStatusLogOpenApiModel) {
    return operators.value[item.operatorLogin];
}

function getDescr(item: OperatorApplicationMessageStatusLogOpenApiModel) {
    if (!item.operatorLogin) {
        return __("Клиент");
    } else {
        let operatorDescr = item.operatorLogin;
        let operator = getOperator(item);
        if (operator) {
            operatorDescr = operator.fio;
            if (props.showOperatorLogins) {
                operatorDescr += ` (${operator.login})`;
            }
        }

        return operatorDescr;
    }
}

onMounted(() => {
    setTimeout(() => {
        emits('reposition');
    }, 1)
});


return (_ctx: any,_cache: any) => {
  const _directive_my_tooltip = _resolveDirective("my-tooltip")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(ReactiveRequestLoader, {
      request: _unref(request),
      "show-loader": false
    }, {
      default: _withCtx(() => [
        (_unref(request).data)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
              (!_unref(request).data.logs.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_1, _toDisplayString(_unref(__)("Статусы не найдены")), 1))
                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_unref(request).data.logs, (item) => {
                    return (_openBlock(), _createElementBlock("div", _hoisted_2, [
                      _createElementVNode("div", _hoisted_3, [
                        (item.operatorLogin)
                          ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                              (getOperator(item))
                                ? (_openBlock(), _createBlock(CoreUiOperatorAvatar, {
                                    key: 0,
                                    operator: getOperator(item)
                                  }, null, 8, ["operator"]))
                                : _createCommentVNode("", true)
                            ], 64))
                          : (__props.client)
                            ? (_openBlock(), _createBlock(CoreUiChatClientAvatar, {
                                key: 1,
                                client: __props.client
                              }, null, 8, ["client"]))
                            : _createCommentVNode("", true)
                      ]),
                      _createElementVNode("div", _hoisted_4, [
                        _createElementVNode("div", _hoisted_5, _toDisplayString(getDescr(item)), 1),
                        _createElementVNode("div", _hoisted_6, [
                          _createElementVNode("div", _hoisted_7, [
                            _withDirectives((_openBlock(), _createElementBlock("span", null, [
                              _createVNode(CoreUiChatHistoryMessageStatus, {
                                "status-id": "delivered",
                                class: "text-muted icon mr-0"
                              }),
                              _createTextVNode(" " + _toDisplayString((new (_unref(DateHelper))(item.dateTimeDelivered)).toLocaleDateTimeString(true)), 1)
                            ])), [
                              [_directive_my_tooltip, {text: _unref(__)('Доставлено'), delay: 1000}]
                            ])
                          ]),
                          _createElementVNode("div", _hoisted_8, [
                            _withDirectives((_openBlock(), _createElementBlock("span", null, [
                              _createVNode(CoreUiChatHistoryMessageStatus, {
                                "status-id": "readed",
                                class: "text-muted icon"
                              }),
                              (item.dateTimeRead)
                                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                                    _createTextVNode(_toDisplayString((new (_unref(DateHelper))(item.dateTimeRead)).toLocaleDateTimeString(true)), 1)
                                  ], 64))
                                : (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(_unref(__)("Не прочитано")), 1))
                            ])), [
                              [_directive_my_tooltip, {text: _unref(__)('Прочтено'), delay: 1000}]
                            ])
                          ])
                        ])
                      ])
                    ]))
                  }), 256))
            ], 64))
          : _createCommentVNode("", true)
      ]),
      _: 1
    }, 8, ["request"]),
    (_unref(request).isLoading)
      ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
          _createVNode(MyLoader, { big: "" })
        ]))
      : _createCommentVNode("", true)
  ]))
}
}

})